import { jsxs as o, jsx as a, Fragment as I } from "react/jsx-runtime";
import { useRef as C, useState as R, useEffect as x } from "react";
import { Input as V } from "../Input/Input.js";
import { CustomDataList as j } from "../CustomDataList/CustomDataList.js";
import { ActionButton as z } from "../ActionButton/ActionButton.js";
import { ResultsTable as A } from "../ResultsTable/ResultsTable.js";
import { AdBlock as K } from "../AdBlock/AdBlock.js";
import { statesForCustomList as T } from "../../data-resources/FakeDataResource.js";
import { publish as F } from "../../utils/events.js";
import { classes as n } from "../../utils/helpers.js";
import '../../assets/ChannelSearch.css';const r = {
  "channel-search": "_channel-search_11pkr_6",
  "channel-search__inputs": "_channel-search__inputs_11pkr_19",
  "ad-wrapper": "_ad-wrapper_11pkr_42",
  "results-table__header": "_results-table__header_11pkr_46",
  "results-table__header--compact": "_results-table__header--compact_11pkr_53",
  "channel-search__submit-btn": "_channel-search__submit-btn_11pkr_87",
  "channel-search__label": "_channel-search__label_11pkr_90"
};
function J({
  network: l,
  baseApiUrl: $,
  authApiUrl: Y,
  ct: E,
  allowZipcodeSearch: u = !0,
  allowStateSearch: _ = !0,
  compactLayout: m = !1,
  allowAutoScroll: S = !0,
  autoScrollOffset: k = 25,
  ad: i = {
    campaign: "",
    source: "",
    medium: "",
    content: ""
  }
}) {
  const y = C(""), h = async (c = { type: "", term: "" }) => {
    const f = async () => {
      const e = `${$}/${l.slug}?${c.type}=${c.term}`;
      try {
        const t = await fetch(e);
        return t.ok ? (await t.json()).map((s) => ({
          city: `${s.city}, ${s.state.toUpperCase()}`,
          call_letters: s.call_letters,
          ota: s.ota,
          provider: s.cable !== null && s.cable !== "" ? s.cable : s.satellite
        })) : (console.error(`Response not OK from ${e}`), []);
      } catch (t) {
        return console.error(t), [];
      }
    };
    return c.term === "" ? [] : await f();
  }, N = async (c) => {
    c.preventDefault();
    const f = new FormData(document.getElementById("channel-search"));
    let e = {};
    for (let [t, p] of f.entries())
      e = {
        ...e,
        [t]: p
      };
    if (e.zipcode && (e == null ? void 0 : e.zipcode) !== "")
      d(await h({ type: "zip", term: e.zipcode })), b(!0);
    else if (e.state && (e == null ? void 0 : e.state) !== "") {
      const t = T.find((p) => Number.parseInt(p.id, 10) === Number.parseInt(e.state, 10));
      y.current = t.label, d(await h({ type: "state", term: t.value })), b(!0);
    } else
      d(await h()), b(!1);
    setTimeout(() => {
      F("scripps:action:completed");
    }, 250);
  }, B = [
    {
      title: "City",
      resultKey: "city"
    },
    {
      title: "Station",
      resultKey: "call_letters"
    },
    {
      title: "Antenna Channel",
      resultKey: "ota"
    },
    {
      title: "Cable/Satellite",
      resultKey: "provider"
    }
  ], [g, d] = R(h()), [w, b] = R(!1), v = C();
  return x(() => {
    w && S && setTimeout(() => {
      window.scroll({
        left: 0,
        top: v.current.getBoundingClientRect().y + window.pageYOffset - k,
        behavior: "smooth"
      });
    }, 100);
  }), /* @__PURE__ */ o("channel-search__wrapper", { children: [
    /* @__PURE__ */ o(
      "form",
      {
        className: n([
          r["channel-search"],
          "channel-search"
        ]),
        id: "channel-search",
        children: [
          /* @__PURE__ */ o("span", { className: n([r["channel-search__label"], "channel-search__label"]), children: [
            l.brand_name,
            " Channel Search:"
          ] }),
          /* @__PURE__ */ o("span", { className: n([r["channel-search__inputs"], "channel-search__inputs"]), children: [
            u && /* @__PURE__ */ a(V, { name: "zipcode", placeholder: "Enter ZIP Code", showValidation: !1 }),
            u && _ && "or",
            _ && /* @__PURE__ */ a(j, { name: "state", options: T, placeholder: "Select Your State", showValidation: !1 })
          ] }),
          /* @__PURE__ */ a(z, { label: "Submit", type: "submit", onClick: N, classname: n(["channel-search__submit-btn", r["channel-search__submit-btn"]]) })
        ]
      }
    ),
    w && /* @__PURE__ */ o(I, { children: [
      /* @__PURE__ */ a(
        "div",
        {
          className: n([
            r["results-table__header"],
            "search-results-header",
            m ? r["results-table__header--compact"] : ""
          ]),
          ref: v,
          children: g.length > 1 ? `${_ && !u ? y.current : "Your"} ${l.brand_name} Channels` : `Your ${l.brand_name} Channel`
        }
      ),
      /* @__PURE__ */ a(
        A,
        {
          columns: B,
          results: g,
          noResultsMsg: `Sorry there are no channels carrying ${l.brand_name} in your area at this time.`,
          compactLayout: m
        }
      )
    ] }),
    !m && /* @__PURE__ */ a("div", { className: n([r["ad-wrapper"], "ad-wrapper"]), children: /* @__PURE__ */ a(
      K,
      {
        ad: {
          header: "Fall in love with subscription-free TV.",
          description: "Watch popular shows for free. It's not fantasy, it's reality.",
          href: "https://www.tablotv.com",
          linkText: "See Deals",
          campaign: i.campaign,
          source: i.source,
          medium: i.medium,
          content: i.content
        },
        image: {
          url: "https://cdn.scrippscloud.com/web/images/tablo/logos/Tablo_TV_Logo_2Color_White_RGB-cropped.png",
          mobile: "https://cdn.scrippscloud.com/web/images/tablo/logos/Tablo_TV_Logo_2Color_Navy_RGB-cropped.png",
          altText: "TABLO TV",
          text: "Internet serv. and antenna purchase req. User interface subject to change. Channels & content subj. to avail."
        },
        theme: "tablotv"
      }
    ) })
  ] });
}
export {
  J as ChannelSearch,
  J as default
};
